"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M14.436 3.602a2.594 2.594 0 0 0-.787-.102h-3c-.808 0-1.243.354-1.518.774a2.95 2.95 0 0 0-.33.726h6.71a6.395 6.395 0 0 0-.297-.752l-.01-.024c-.174-.345-.459-.525-.767-.622ZM16.552 5a6.754 6.754 0 0 0-.232-.706 7.867 7.867 0 0 0-.203-.473l-.014-.03-.004-.008V3.78l-.003-.004c-.327-.655-.875-.975-1.359-1.128-.47-.148-.907-.148-1.082-.148H10.65c-1.188 0-1.92.562-2.355 1.226-.286.437-.442.919-.536 1.274H4.15c-.713 0-1.34.447-1.563 1.123-.228.69-.007 1.502.7 2.223l3.59 3.829-.73 6.798V19c0 .963.412 1.613.958 2.006.52.374 1.128.494 1.542.494h7c.963 0 1.613-.412 2.005-.958.317-.452.49-.99.495-1.542v-.029l-.004-.028a558.409 558.409 0 0 0-.413-3.483 4.153 4.153 0 0 0 1.56-.532c.745-.45 1.358-1.225 1.358-2.428v-4c0-.487-.14-1.328-.566-2.063C19.641 5.679 18.871 5 17.65 5h-1.097Zm-.832 1H8.594l-.7 6.055-.478 4.445h9.432c-.25-2-.466-4.004-.647-6.012l-.06-.63c-.14-1.495-.278-2.86-.42-3.858Zm1.247 11.5H7.31l-.163 1.525c.007.621.258.965.542 1.17.313.225.704.305.958.305h7c.637 0 .987-.254 1.194-.542.218-.303.3-.678.305-.932-.058-.509-.118-1.017-.178-1.526Zm-9.944-6.629L7.588 6H4.15a.636.636 0 0 0-.613.437c-.08.245-.055.681.467 1.213l.008.008 3.012 3.213ZM16.73 6h.92c.777 0 1.256.405 1.566.938.322.556.431 1.216.431 1.562v4c0 .797-.38 1.272-.875 1.572-.365.22-.79.342-1.163.395-.15-1.294-.284-2.71-.412-4.073l-.06-.63C17.002 8.348 16.87 7.016 16.73 6Z",
    clipRule: "evenodd"
  })]
});